import React from 'react';

export const Services = (props) => {
  return (
    <div
      style={{
        fontFamily: "'Perpetua', 'Times New Roman', serif",
      }}
      id="services"
      className="text-center"
    >
      <div className="container">
        <div className="section-title">
          <h2>Our Services</h2>
          <p>
            The Firm is committed to delivering clear, practical, and timely
            legal advice tailored to support clients’ business objectives. Its
            solutions are innovative, pragmatic, and specifically crafted to
            meet each client’s unique needs
          </p>
        </div>
        <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={`${d.name}-${i}`}
                  className="col-md-4 col-sm-6"
                  style={{
                    marginBottom: '30px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <i className={d.icon}></i>
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    <p>{d.text}</p>
                  </div>
                </div>
              ))
            : 'loading'}
        </div>
      </div>
    </div>
  );
};
